import React, { useCallback, useRef, useState, useEffect } from "react";
import { Input } from "components/bootstrap";
import { isValidURL } from "util/URLUtils";
import URLAllowListFormModal from "components/common/URLAllowListFormModal";
import { urlAllowListCheck, urlAllowListGenerateRegex } from "api/tools";
import { triggerInput } from "util/FormsUtils";
const URLAllowListInput = ({
  label,
  onChange,
  validationMessage = "",
  validationState = void 0,
  url = "",
  onValidationChange = () => {
  },
  labelClassName = "",
  wrapperClassName = "",
  urlType = "literal",
  autofocus = true,
  placeholder = void 0
}) => {
  const [isAllowlisted, setIsAllowlisted] = useState(false);
  const [currentValidationState, setCurrentValidationState] = useState(validationState);
  const [ownValidationMessage, setOwnValidationMessage] = useState(validationMessage);
  const suggestRegexAllowlistUrl = (typedUrl, type) => {
    const keyWildcard = "${key}";
    return type && type === "regex" && isValidURL(typedUrl) ? urlAllowListGenerateRegex(typedUrl, keyWildcard) : typedUrl;
  };
  const [suggestedUrl, setSuggestedUrl] = useState(url);
  const isAllowlistError = () => currentValidationState === "error" && isValidURL(url);
  const urlInputRef = useRef();
  const checkIsAllowlisted = useCallback(() => {
    if (url) {
      const promise = urlAllowListCheck(url);
      promise.then((result) => {
        if (!result.is_allowlisted && validationState === null) {
          setCurrentValidationState("error");
          onValidationChange("error");
          const message = isValidURL(url) ? `URL ${url} is not allowlisted` : `URL ${url} is not a valid URL.`;
          setOwnValidationMessage(message);
        } else {
          setOwnValidationMessage(validationMessage);
          setCurrentValidationState(validationState);
          onValidationChange(validationState);
        }
        setIsAllowlisted(result.is_allowlisted);
      });
    }
  }, [url, validationMessage, validationState, onValidationChange]);
  const onUpdate = () => {
    triggerInput(urlInputRef.current.getInputDOMNode());
    checkIsAllowlisted();
  };
  useEffect(() => {
    const checkSuggestion = () => {
      if (url) {
        const suggestion = suggestRegexAllowlistUrl(url, urlType);
        if (typeof suggestion === "object") {
          suggestion.then((result) => {
            setSuggestedUrl(result.regex);
          });
        } else {
          setSuggestedUrl(url);
        }
      }
    };
    const timer = setTimeout(() => checkSuggestion(), 250);
    return () => clearTimeout(timer);
  }, [url, urlType]);
  useEffect(() => {
    const timer = setTimeout(() => checkIsAllowlisted(), 250);
    return () => clearTimeout(timer);
  }, [url, validationState, checkIsAllowlisted]);
  const addButton = isAllowlistError() && !isAllowlisted ? /* @__PURE__ */ React.createElement(URLAllowListFormModal, { newUrlEntry: suggestedUrl, onUpdate, urlType }) : "";
  const helpMessage = /* @__PURE__ */ React.createElement(React.Fragment, null, validationState === null ? ownValidationMessage : validationMessage, " ", addButton);
  return /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "text",
      id: "url",
      name: "url",
      label,
      ref: urlInputRef,
      autoFocus: autofocus,
      required: true,
      placeholder,
      onChange,
      help: helpMessage,
      bsStyle: currentValidationState,
      value: url,
      labelClassName,
      wrapperClassName
    }
  );
};
export default URLAllowListInput;
